<template>
  <div class="pf-root">
    <div class="pf-row">
      <div class="pf-group">
        <label class="pf-label">Restaurantes</label>
        <el-select
          :value="restaurantes"
          multiple
          filterable
          clearable
          collapse-tags
          placeholder="Todos os restaurantes"
          class="pf-select"
          @input="$emit('update:restaurantes', $event)"
        >
          <el-option
            v-for="opt in opcoes"
            :key="opt.value"
            :label="opt.label"
            :value="opt.value"
          />
        </el-select>
      </div>

      <div class="pf-group">
        <label class="pf-label">Data início</label>
        <flat-picker
          :value="start"
          placeholder="Data início"
          :config="{ ...pickerConfig, maxDate: end || null, static: true }"
          class="form-control pf-date"
          @on-change="(v) => $emit('update:start', v[0] ? fmt(v[0]) : null)"
        />
      </div>

      <div class="pf-group">
        <label class="pf-label">Data fim</label>
        <flat-picker
          :value="end"
          placeholder="Data fim"
          :config="{ ...pickerConfig, minDate: start || null, static: true }"
          class="form-control pf-date"
          @on-change="(v) => $emit('update:end', v[0] ? fmt(v[0]) : null)"
        />
      </div>

      <div class="pf-actions">
        <button class="pf-btn-apply" @click="filtrar">
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
          </svg>
          Filtrar
        </button>
        <button class="pf-btn-clear" @click="limpar" title="Limpar">
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <path d="M18 6 6 18M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import flatPicker from "vue-flatpickr-component";
  import { Portuguese } from "flatpickr/dist/l10n/pt.js";
  import "flatpickr/dist/flatpickr.css";
  import { Select, Option } from "element-ui";

  export default {
    name: "PerfilFiltros",
    components: { flatPicker, [Select.name]: Select, [Option.name]: Option },
    props: {
      opcoes: { type: Array, default: () => [] },
      restaurantes: { type: Array, default: () => [] },
      start: { default: null },
      end: { default: null },
    },
    data() {
      return {
        pickerConfig: {
          locale: Portuguese,
          altInput: true,
          allowInput: true,
          altFormat: "d/m/Y",
          dateFormat: "Y-m-d",
        },
      };
    },
    methods: {
      fmt(d) {
        return d ? new Date(d).toISOString().slice(0, 10) : null;
      },
      limpar() {
        this.$emit("update:start", null);
        this.$emit("update:end", null);
        this.$emit("update:restaurantes", []);
        this.$emit("filtrar");
      },
      filtrar() {
        this.$emit("filtrar");
      },
    },
  };
</script>

<style scoped>
  .pf-root {
    background: #fff;
    border: 1.5px solid #f0ece8;
    border-radius: 14px;
    padding: 16px 20px;
    margin-bottom: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  }
  .pf-row {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    flex-wrap: wrap;
  }
  .pf-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
    flex: 1;
    min-width: 150px;
  }
  .pf-label {
    font-size: 11px;
    font-weight: 700;
    color: #b0a8a0;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin: 0;
  }
  .pf-select {
    width: 100%;
  }
  .pf-select .el-input__inner {
    border: 1.5px solid #e8e4e0 !important;
    border-radius: 9px !important;
    font-size: 13px !important;
    height: 36px !important;
    line-height: 36px !important;
    font-family: inherit !important;
  }
  .pf-date {
    border: 1.5px solid #e8e4e0 !important;
    border-radius: 9px !important;
    font-size: 13px !important;
    height: 36px !important;
    padding: 0 10px !important;
  }
  .pf-date:focus {
    border-color: #ff825d !important;
    box-shadow: 0 0 0 3px rgba(255, 130, 93, 0.12) !important;
  }
  .pf-actions {
    display: flex;
    gap: 8px;
    align-items: flex-end;
    padding-bottom: 1px;
  }
  .pf-btn-apply {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    background: #ff825d;
    color: #fff;
    border: none;
    border-radius: 9px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s;
    font-family: inherit;
    white-space: nowrap;
  }
  .pf-btn-apply:hover {
    background: #e86b45;
  }
  .pf-btn-clear {
    width: 36px;
    height: 36px;
    border-radius: 9px;
    border: 1.5px solid #e8e4e0;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #b0a8a0;
    cursor: pointer;
    transition: all 0.12s;
  }
  .pf-btn-clear:hover {
    border-color: #e05a3a;
    color: #e05a3a;
  }
  @media (max-width: 768px) {
    .pf-row {
      flex-direction: column;
    }
    .pf-group {
      min-width: 100%;
    }
    .pf-actions {
      width: 100%;
    }
    .pf-btn-apply {
      flex: 1;
      justify-content: center;
    }
  }
</style>
